import styled from "styled-components";
import { smoothIn } from "../../styles/keyframes";

// Toast looks better if it can be scrolled away, so it is not fixed to the top
export const TopBannerContainer = styled.div`
  top: 0;
  left: 0;
  width: 100%;
`;

/**
 * Yellow strip for account notices, e.g. unverified email. Put one or more in a TopBannerContainer.
 * Children are laid out in centered rows: wrap an icon, `h5` text and optional `button` or `a` in a `div`.
 */
export const TopBanner = styled.div`
  padding: 5px;
  background: var(--status-yellow);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.1);
  animation: ${smoothIn} 0.4s;
  margin-bottom: 2px;

  div {
    display: flex;
    width: 100%;
    align-items: center;
    align-content: center;
    justify-content: center;
    h5 {
      margin: 0 5px;
    }

    svg {
      width: 25px;
    }

    button,
    a {
      border-radius: 20px;
      padding: 4px 15px;
      border: none;
      outline: none;
      font-weight: 600;
      color: var(--grey);
      transition: 0.4s;
      &:hover {
        transition: 0.4s;
        color: var(--key-color-2);
      }
    }

    // Make a link look like the browser's default button, which is what the buttons above get
    a {
      width: auto;
      background: buttonface;
      font-size: 13.3333px;
      white-space: nowrap;
    }
  }
`;
